import React from 'react';
import { Modal } from 'antd';

type Props = {
    open: boolean;
    onOk: () => void;
    onCancel: () => void;
    isOn: boolean;
};

const TurnOnInsuranceModal = (props: Props) => {
    const { open, onOk, onCancel, isOn } = props;
    return (
        <Modal
            title={`Turn ${isOn ? 'on' : 'off'} insurance services?`}
            open={open}
            onOk={onOk}
            onCancel={onCancel}
            okText="Confirm"
            okButtonProps={{
                danger: !isOn,
                type: 'primary',
            }}
        >
            <div>
                <p>
                    {
                        isOn ?
                            'Turning on insurance services for this state will enable insurance options on the HelloKlarity website. Are you sure you want to proceed?' :
                            'Turning off insurance services for this state will immediately disable insurance options on the HelloKlarity website. Are you sure you want to proceed?'
                    }
                </p>
            </div>
        </Modal>
    );
};

export default TurnOnInsuranceModal;
